var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.1,
    height: 17.14,
    viewBox: "0 0 17.1 17.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,5.5a.31.31,0,0,1-.2-.1.31.31,0,0,1-.2-.1l-.2-.2c-.2-.2-.5-.5-.6-.5a4.42,4.42,0,0,0-1.9-.7H8.8a3,3,0,0,0-1.7.2,3.44,3.44,0,0,0-1.4.8,4,4,0,0,0-1,1.3c-.3.8-.3,1.5-.3,3.9v5.4a9.18,9.18,0,0,0,.1,1.8A6.52,6.52,0,0,0,5,18.8,4.13,4.13,0,0,0,5.9,20a2.19,2.19,0,0,0,.5.3,4.54,4.54,0,0,0,.8.3,38.94,38.94,0,0,0,4.5.4c0-.1,0-.1.1-.2s.6,0,1,0h.9a10.48,10.48,0,0,0,3.2-.6,21.78,21.78,0,0,1-4.4-.1,25.16,25.16,0,0,0-3.7-.5,3.22,3.22,0,0,1-.8-.1,2.82,2.82,0,0,1-1.7-.9c-.6-.6-.6-1.4-.7-2.8V8a2.41,2.41,0,0,1,.3-1.5,2.43,2.43,0,0,1,.7-.9,3.49,3.49,0,0,1,1.3-.5A6.73,6.73,0,0,1,9.7,5h5.9c.4.1.6.1.9.2A6.29,6.29,0,0,0,18.8,5.5Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,20.9c-2.7,0-4.2-1.5-4.2-4.2V9.5c0-2.7,1.5-4.2,4.2-4.2h5.8c2.7,0,4.2,1.5,4.2,4.2v7.3c0,2.7-1.5,4.2-4.2,4.2H11.5ZM8.4,9.5v7.3c0,2.1,1,3.1,3.1,3.1h5.8c2.1,0,3.1-1,3.1-3.1V9.5c0-2.1-1-3.1-3.1-3.1H11.5C9.4,6.4,8.4,7.4,8.4,9.5Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,9.4",
    transform: "translate(-4.4 -3.86)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_104",
    "data-name": "Capa 104"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,14.4a3.5,3.5,0,1,1,3.5,3.5A3.48,3.48,0,0,1,11.9,14.4Zm.5,0a3,3,0,0,0,3,3,3,3,0,0,0,0-6A3,3,0,0,0,12.4,14.4Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,18.5l-.7-.7a.28.28,0,0,1,.4-.4l.7.7a.28.28,0,0,1-.4.4Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,15.7l-.9-.9a.45.45,0,0,1,0-.5.45.45,0,0,1,.5,0l.7.7,1.6-1.6a.35.35,0,0,1,.5.5l-1.8,1.8a.31.31,0,0,1-.2.1C15,15.8,14.9,15.8,14.8,15.7Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,15H10.3a.47.47,0,0,1-.5-.5v-.3a.47.47,0,0,1,.5-.5h1.6a.47.47,0,0,1,.5.5v.3C12.3,14.8,12.1,15,11.9,15Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3,12.3H10.2a.47.47,0,0,1-.5-.5v-.2a.47.47,0,0,1,.5-.5h4a4.89,4.89,0,0,1-.5.7l-.3.3C13.5,12.2,13.4,12.2,13.3,12.3Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,9.6H10.3a.47.47,0,0,1-.5-.5V8.9a.47.47,0,0,1,.5-.5h8.5a.47.47,0,0,1,.5.5v.2A.54.54,0,0,1,18.8,9.6Z",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,11.2",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,11.1",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.3,
    y1: 7.24,
    x2: 9.2,
    y2: 7.24,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-4.4 -3.86)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsSearch);
export default __webpack_public_path__ + "static/media/documents-search.81164699baf8c8bbc86b9c9d45c9d51b.svg";
export { ForwardRef as ReactComponent };